import React from 'react';
import { CheckCircle, ErrorOutline, Cancel } from '@mui/icons-material';
import { colors } from 'styles/colors';
import { PaymentResultIconProps } from './types';

const PaymentResultIcon: React.FC<PaymentResultIconProps> = ({ status }) => {
  const getIconConfig = () => {
    switch (status) {
      case 'success':
        return {
          Icon: CheckCircle,
          color: colors.successGreen
        };
      case 'failure':
        return {
          Icon: ErrorOutline,
          color: colors.red
        };
      case 'cancelled':
        return {
          Icon: Cancel,
          color: colors.orange
        };
      default:
        return {
          Icon: ErrorOutline,
          color: colors.red
        };
    }
  };

  const { Icon, color } = getIconConfig();

  return (
    <Icon 
      sx={{ 
        fontSize: 80, 
        color: color, 
        mb: 3 
      }} 
    />
  );
};

export default PaymentResultIcon;